import { useState } from 'react';

import API from '../../../../libs/api';

export function useQuestions(merchantProduct) {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);

  async function refreshQuestions(filters) {
    setLoading(true);
    const params = { merchant_product: merchantProduct.id };
    if (filters?.selectedGroup) {
      params.question_group = +filters.selectedGroup;
    }
    if (filters?.searchQuery) {
      params.search = filters.searchQuery;
    }
    if (filters?.selectedStatus) {
      params.status = filters.selectedStatus;
    }
    try {
      const data = await API.getQuestions(params);
      setQuestions(data);
    } finally {
      setLoading(false);
    }
  }

  async function createQuestion(questionData) {
    setLoading(true);
    try {
      const newQuestion = await API.createQuestion({
        ...questionData,
        merchantProduct: merchantProduct.id,
      });
      setQuestions((prev) => [...prev, newQuestion]);
    } finally {
      setLoading(false);
    }
  }

  async function updateQuestion(questionId, questionData) {
    setLoading(true);
    try {
      const updated = await API.updateQuestion(questionId, questionData);
      setQuestions((prev) => prev.map((q) => (q.id === questionId ? updated : q)));
    } finally {
      setLoading(false);
    }
  }

  async function deleteQuestion(questionId) {
    setLoading(true);
    try {
      await API.deleteQuestion(questionId);
      setQuestions((prev) => prev.filter((q) => q.id !== questionId));
    } finally {
      setLoading(false);
    }
  }

  async function bulkDeleteQuestions(questionIds) {
    setLoading(true);
    try {
      await Promise.all(questionIds.map((id) => API.deleteQuestion(id)));
      setQuestions((prev) => prev.filter((q) => !questionIds.includes(q.id)));
    } finally {
      setLoading(false);
    }
  }

  async function bulkUpdateStatus(questionIds, status) {
    setLoading(true);
    try {
      const updatedQuestions = await Promise.all(
        questionIds.map((id) => API.updateQuestion(id, { status })),
      );
      setQuestions((prev) =>
        prev.map((q) =>
          questionIds.includes(q.id) ? updatedQuestions.find((uq) => uq.id === q.id) || q : q,
        ),
      );
    } finally {
      setLoading(false);
    }
  }

  async function bulkAssignGroups(questionIds, groups) {
    setLoading(true);
    try {
      const updatedQuestions = await Promise.all(
        questionIds.map((id) => API.updateQuestion(id, { groups })),
      );
      setQuestions((prev) =>
        prev.map((q) =>
          questionIds.includes(q.id) ? updatedQuestions.find((uq) => uq.id === q.id) || q : q,
        ),
      );
    } finally {
      setLoading(false);
    }
  }

  const questionOperations = {
    createQuestion,
    updateQuestion,
    deleteQuestion,
    refreshQuestions,
    bulkDeleteQuestions,
    bulkUpdateStatus,
    bulkAssignGroups,
  };

  return {
    questions,
    loading,
    setQuestions,
    setLoading,
    questionOperations,
    ...questionOperations,
  };
}
